import jwtDecode from 'jwt-decode';
import axios from 'axios';

import config from '../../config';
import useAuth from '../../hooks/useAuth';
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;

// intercepting to capture errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;
        
            switch (error.response.status) {
                case 401:
                    if(error.response.data.error){
                        message= {'non_field_errors': error.response.data.error};
                    }
                    else {
                        message = error.response.data;
                    }
                    break;
                case 403:
                    if(error.response.data.error){
                        message= {'non_field_errors': error.response.data.error};
                    }
                    else {
                        message = error.response.data;
                    }
                    break;
                case 404:
                    message = {'non_field_errors': 'The resource you are looking for could not be found.'};
                    break;
                // case 300:
                //     message = {'non_field_errors': error.response.data.error};
                    // break;
                case 400:
                    if(error.response.data.error){
                        message= {'non_field_errors': error.response.data.error};
                    }
                    else {
                        message = error.response.data;
                    }
                    break;
                case 500:
                    message ={'non_field_errors': 'There is an error. Please try again later.'};
                    break;
                default: {
                    message =
                        error.response && error.response.data ? error.response.data['message'] : error.message || error;
                }
            }
            return Promise.reject(message);
        
    }
);

const AUTH_SESSION_KEY = 'adminto_user';

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = () => {
    return true;
};

const getUserFromCookie = () => {

    const user = localStorage.getItem('LoggedIn');
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};
class APICore {
    /**
     * Fetches data from given url
     */
    get = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, params);
        } else {
            response = axios.get(`${url}`, params);
        }
        return response;
    };

    getFile = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * post given data to url
     */
    create = (url: string, data: any) => {
        return axios.post(url, data, {withCredentials: true},);
    };

    /**
     * Updates patch data
     */
    updatePatch = (url: string, data: any) => {
        return axios.patch(url, data,{withCredentials: true});
    };

    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.put(url, data,{withCredentials: true});
    };

    /**
     * Deletes data
     */
    delete = (url: string) => {
        return axios.delete(url,{withCredentials: true});
    };

    /**
     * post given data to url with file
     */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

isUserAuthenticated = () => {
  const user = this.getLoggedInUser();

  if (!user) {
        return false;
  }

  return true;
};


    setLoggedInUser = (session: any) => {
        if (session.status===200) localStorage.setItem('LoggedIn', JSON.stringify(true));
        else {
            localStorage.removeItem('LoggedIn');
        }
    };
    setLoggedOutUser = (session: any) => {
        const {auth,setAuth}=useAuth();
        if (session.status==200){
            setAuth({});
            localStorage.removeItem('LoggedIn');
        }

    };
    
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getUserFromCookie();
    };
    

    setUserInSession = (modifiedUser: any) => {
        let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
    };
}

/*
Check if token available in session
*/
let user = getUserFromCookie();

if (user) {

        setAuthorization();

}

export { APICore, setAuthorization };
